import React, { Component } from 'react'
import { connect } from 'react-redux'
import { InstantSearch, Configure } from 'react-instantsearch/dom'


   		// <Configure filters="archived!=1 AND parentArchived!=1" />
class AlgoliaSearchWrapperContainer extends Component {

	render() {


		if(this.props.algoliaSearchKey){
			return(
				<InstantSearch
					appId={process.env.REACT_APP_PLICKERS_ALGOLIA_APP_ID}
					apiKey={this.props.algoliaSearchKey}
					// indexName={'repos'}
					indexName={this.props.isSectionHome?'sets_questions':'repos'}
					searchState={this.props.searchState}
    				createURL={this.props.createURL}
   					onSearchStateChange={this.props.onSearchStateChange}
				>
				<Configure filters="archived!=1 AND parentArchived!=1" />
					{this.props.children}
				</InstantSearch>
			)
		}
		else if(this.props.isTopNav)
		{
			return <input disabled={true} className='topNav-search'/>
		} else return null
	}
}

function mapStateToProps(state) {
	const searchKey=state.searchKey
	let contentsSearchKey
	if(searchKey){
		contentsSearchKey=searchKey.contents
	}
	return {
		 algoliaSearchKey:contentsSearchKey
	}
}



export default connect(
	mapStateToProps,
	{ }
)(AlgoliaSearchWrapperContainer)









// WEBPACK FOOTER //
// ./src/containers/search/AlgoliaSearchWrapperContainer.js